import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ConstantsModule } from '../constants/constants.module';
import { DialogPage } from '../root_classes/dialog-page';

@Component({
  selector: 'app-folder-restart',
  templateUrl: './folder-restart.component.html',
  styleUrls: ['./folder-restart.component.scss']
})
export class FolderRestartComponent extends DialogPage implements OnInit {

  // Form data.
	folderRestartForm = new FormGroup({
		emailSendControl: new FormControl(false),
	});

  // Extra data.
	public folderId: string = "";
	public folderName: string = "";
	public buttonText: string;
	public enableAction: boolean;

  constructor(constantsModule:ConstantsModule, cookieService:CookieService, httpClient:HttpClient, router:Router, modalService:NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Save button infos.
		this.buttonText = "Relancer";
		this.enableAction = true;
	}

  ngOnInit(): void {
  }

  public setModalOptions(data:any):void {
		this.folderId = data["id"];
		this.folderName = data["name"];
	}

  public save(): void {
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
			folderid:this.folderId,
			restart: true,
			sendMail: this.folderRestartForm.controls["emailSendControl"].value,
		};
		this.put("/api/folder-start", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					var modifiedFolder = {
						endDate: response.ENDDATE,
						endDateVal: response.ENDDATEVAL
					};
					this.modalInstance.dismiss(modifiedFolder);
				}
			},
			(err:any) => {
				this.modalInstance.close(err);
			}
		);
	}
}
